import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

// Local Deps
import './RFQRecipientGrid.scss';

export default class RejectedRequest extends React.PureComponent {
  static propTypes = {
    quoteDetails: PropTypes.array.isRequired,
  };

  render() {
    const currencyKeys = ['Unit Price', 'Shipping Cost', 'Total Cost'];

    const { quoteDetails } = this.props;
    const pageSize = 12;
    const half = Math.ceil(quoteDetails.length / 2);

    const firstHalf = quoteDetails.splice(0, half);
    const secondHalf = quoteDetails.splice(-half);

    // Note that the grid configFile for this directory does not configure the request table, but the details table inside of the modal.
    const columns = [
      {
        Header: '',
        accessor: 'key',
        Cell: cellProps => (
          // const href = cellProps.value.split('-').pop();

          <span style={{ fontWeight: 600 }}>{cellProps.value}</span>
        ),
      },
      {
        Header: '',
        accessor: 'value',
        Cell: cellProps => {
          // const href = cellProps.value.split('-').pop();
          if (currencyKeys.indexOf(cellProps.original.key) !== -1) {
            console.log(cellProps.original, currencyKeys);
            return <span>${Number(cellProps.original.value).toFixed(2)}</span>;
          }
          return <span>{cellProps.value}</span>;
        },
      },
    ];

    return (
      <div className="nf-view-users-grid" style={{ display: 'flex' }}>
        <div style={{ width: '50%' }}>
          <ReactTable
            data={firstHalf}
            columns={columns}
            className=" -striped"
            showPageSizeOptions={false}
            showPagination={false}
            defaultPageSize={pageSize}
          />
        </div>
        <div style={{ width: '50%' }}>
          <ReactTable
            data={secondHalf}
            columns={columns}
            className=" -striped"
            showPageSizeOptions={false}
            showPagination={false}
            defaultPageSize={pageSize}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/QuoteDetailTable/quoteDetailTable.jsx